import { InboxListItemInfoFragment } from 'src/api';
import { InboxItemExtended } from 'src/types/inbox';

import { InboxItemTypeWithResources } from './inbox';

export const RESOURCES_INBOX_ITEM_ID = 'resources-inbox-item';

export const RESOURCES_INBOX_ITEM: InboxItemExtended<InboxListItemInfoFragment> = {
  id: RESOURCES_INBOX_ITEM_ID,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  isUnread: true,
  type: InboxItemTypeWithResources.Resources,
  lastActivityDate: null,
  lastActivityHeading: null,
  subEntityType: null,
  subEntityStatus: null,
  employeeFullName: null,
  employeeAvatarUrl: null,
  verifierCompanyName: null,
  verifierLogoUrl: null,
  contributorCompanyName: null,
  contributorLogoUrl: null,
  permissiblePurposeId: null,
  stripePaymentStatus: null,
};
